export { default } from './SubHeading'
export * from './SubHeading'
